<template>
	<div>
		<teach-video-content :teachChapter="teachChapter"></teach-video-content>
		<video-footer></video-footer>
	</div>
</template>

<script>
	import TeachVideoContent from '@/pages/teach/components/TeachVideoContent'
	import VideoFooter from '@/pages/common/VideoFooter'
	import axios from 'axios'
	export default {
		name: 'TeachCourse',
		components: {
			TeachVideoContent,
			VideoFooter
		},
		data() {
			return {
				teachChapter: []
			}
		},
		methods: {
			getDataInfo(cid) {
				axios.get('/itmswcn/chapter/queryForTeach/' + cid)
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.teachChapter = data
				}
			}
		},
		mounted() {
			this.getDataInfo(this.$route.query.cid)
		}
	};
</script>

<style lang="scss" scoped>

</style>